import { EnumPipefyInputFieldIds } from "pages/Pipefy/enum";

export const specialDownloadIds: EnumPipefyInputFieldIds[] = [
  EnumPipefyInputFieldIds.ANEXO_RECLAMACAO_TECNICA,
  EnumPipefyInputFieldIds.PDF_CARTA_TROCA,
  EnumPipefyInputFieldIds.ANEXOS_BOLETIM_OCORRENCIA_COMPLEMENTO_EXTRAVIO,
  EnumPipefyInputFieldIds.ANEXOS_AUTORIZACAO_DADOS,
];